var map = {
	"./Acacia Arrow Shafts.png": 469,
	"./Acacia Bark.png": 470,
	"./Acacia Logs.png": 471,
	"./Acacia Longbow.png": 472,
	"./Acacia Sapling.png": 473,
	"./Acacia Seed.png": 474,
	"./Acacia Shortbow.png": 475,
	"./Accuracy Potion.png": 476,
	"./Accuracy Skill Orb (g).png": 477,
	"./Accuracy Skill Orb.png": 478,
	"./Actuator Pouch.png": 479,
	"./Adrenal Gland.png": 480,
	"./Airtight Container Package.png": 481,
	"./Airtight Container.png": 482,
	"./Alexandrite.png": 483,
	"./Alien Test Tube.png": 484,
	"./All White Cloak.png": 485,
	"./Amulet of Power.png": 486,
	"./Ancient Blue Dragon Card.png": 487,
	"./Ancient Blue Dragon Foil.png": 488,
	"./Ancient Green Dragon Card.png": 489,
	"./Ancient Green Dragon Foil.png": 490,
	"./Ancient Red Dragon Card.png": 491,
	"./Ancient Red Dragon Foil.png": 492,
	"./Ancient Yellow Dragon Card.png": 493,
	"./Ancient Yellow Dragon Foil.png": 494,
	"./Angel.png": 495,
	"./Ash.png": 496,
	"./Avocado Seeds.png": 497,
	"./Avocado.png": 498,
	"./Bait.png": 499,
	"./Bandana.png": 500,
	"./Bandit Card.png": 501,
	"./Bandit Foil.png": 502,
	"./Baobab Arrow Shafts.png": 503,
	"./Baobab Bark.png": 504,
	"./Baobab Logs.png": 505,
	"./Baobab Longbow.png": 506,
	"./Baobab Shortbow.png": 507,
	"./Barbarian.png": 508,
	"./Barley.png": 509,
	"./Barracuda.png": 510,
	"./Bat Suit Boots.png": 511,
	"./Bat Suit Bottom.png": 512,
	"./Bat Suit Gloves.png": 513,
	"./Bat Suit Hat.png": 514,
	"./Bat Suit Top.png": 515,
	"./Bear Curry.png": 516,
	"./Bear Hide Boots.png": 517,
	"./Bear Hide Gloves.png": 518,
	"./Bear Hide Hood.png": 519,
	"./Bear Hide Pants.png": 520,
	"./Bear Hide Top.png": 521,
	"./Bear Kebab.png": 522,
	"./Bear Meat.png": 523,
	"./Bear Soup.png": 524,
	"./Bearington Outfit.png": 525,
	"./Beb Card.png": 526,
	"./Beb Foil.png": 527,
	"./Beef Curry.png": 528,
	"./Beef Kebab.png": 529,
	"./Beef Soup.png": 530,
	"./Beef.png": 531,
	"./Beta Cloak.png": 532,
	"./Big River Cloak.png": 533,
	"./Big River Mask.png": 534,
	"./Big River Staff.png": 535,
	"./Bikini Bottom.png": 536,
	"./Bikini Top.png": 537,
	"./Bills Glasses.png": 538,
	"./Binding Actuator.png": 539,
	"./Bishop.png": 540,
	"./Black Beanie.png": 541,
	"./Black Cowboy Hat.png": 542,
	"./Black Dragon Card.png": 543,
	"./Black Dragon Foil.png": 544,
	"./Black Dragon Plasma.png": 545,
	"./Black Firecracker.png": 546,
	"./Black Scarf.png": 547,
	"./Blood of Destruction.png": 548,
	"./Blue Beanie.png": 549,
	"./Blue Dragon Card.png": 550,
	"./Blue Dragon Foil.png": 551,
	"./Blue Dragon Plasma.png": 552,
	"./Blue Firecracker.png": 553,
	"./Blue Reaper.png": 554,
	"./Blue Scarf.png": 555,
	"./Bone Snake Card.png": 556,
	"./Bone Snake Foil.png": 557,
	"./Book of the Damned.png": 558,
	"./Boots of the Bull.png": 559,
	"./Bowl of Water.png": 560,
	"./Bowl.png": 561,
	"./Bowstring Package.png": 562,
	"./Bowstring.png": 563,
	"./Bread.png": 564,
	"./Bronze 2H Sword.png": 565,
	"./Bronze 2H Warhammer.png": 566,
	"./Bronze Acacia Arrows.png": 567,
	"./Bronze Arrowheads.png": 568,
	"./Bronze Axe.png": 569,
	"./Bronze Baobab Arrows.png": 570,
	"./Bronze Bar.png": 571,
	"./Bronze Battleaxe.png": 572,
	"./Bronze Bear Boots.png": 573,
	"./Bronze Bear Gloves.png": 574,
	"./Bronze Bear Hat.png": 575,
	"./Bronze Bear Robe Bottom.png": 576,
	"./Bronze Bear Robe Top.png": 577,
	"./Bronze Bolts.png": 578,
	"./Bronze Boots.png": 579,
	"./Bronze Buckler.png": 580,
	"./Bronze Chainbody.png": 581,
	"./Bronze Dagger.png": 582,
	"./Bronze Gladius.png": 583,
	"./Bronze Gloves.png": 584,
	"./Bronze Halberd.png": 585,
	"./Bronze Helmet.png": 586,
	"./Bronze Katana.png": 587,
	"./Bronze Kiteshield.png": 588,
	"./Bronze Long Sword.png": 589,
	"./Bronze Mace.png": 590,
	"./Bronze Oak Arrows.png": 591,
	"./Bronze Pickaxe.png": 592,
	"./Bronze Pine Arrows.png": 593,
	"./Bronze Platebody.png": 594,
	"./Bronze Platelegs.png": 595,
	"./Bronze Plateskirt.png": 596,
	"./Bronze Psywood Arrows.png": 597,
	"./Bronze Redwood Arrows.png": 598,
	"./Bronze Scimitar.png": 599,
	"./Bronze Short Sword.png": 600,
	"./Bronze Spear.png": 601,
	"./Bronze Staff.png": 602,
	"./Bronze Throwing Knife.png": 603,
	"./Bronze Warhammer.png": 604,
	"./Bronze Weerwood Arrows.png": 605,
	"./Bronze Willow Arrows.png": 606,
	"./Bronze Yellowwood Arrows.png": 607,
	"./Bruhly.png": 608,
	"./Bucket of Water.png": 609,
	"./Bucket.png": 610,
	"./Bunny Ears.png": 611,
	"./Burning Burden E. Stone.png": 612,
	"./Burnt Barracuda.png": 613,
	"./Burnt Chicken.png": 614,
	"./Burnt Chucken.png": 615,
	"./Burnt Crab.png": 616,
	"./Burnt Egg.png": 617,
	"./Burnt Giant Squid.png": 618,
	"./Burnt Guppie.png": 619,
	"./Burnt Lobster.png": 620,
	"./Burnt Meat.png": 621,
	"./Burnt Oyster.png": 622,
	"./Burnt Roast.png": 623,
	"./Burnt Salmon.png": 624,
	"./Burnt Sturgeon.png": 625,
	"./Burnt Tigerfish.png": 626,
	"./Burnt Tuna.png": 627,
	"./Cactuson Card.png": 628,
	"./Cactuson Foil.png": 629,
	"./Cactuson King Card.png": 630,
	"./Cactuson King Foil.png": 631,
	"./Cake.png": 632,
	"./Candy Cane Sword.png": 633,
	"./Cane.png": 634,
	"./Carving Knife.png": 635,
	"./Cat Ears.png": 636,
	"./Catson Archer Card.png": 637,
	"./Catson Archer Foil.png": 638,
	"./Catson Card.png": 639,
	"./Catson Foil.png": 640,
	"./Catson Guard Card.png": 641,
	"./Catson Guard Foil.png": 642,
	"./Catson King Card.png": 643,
	"./Catson King Foil.png": 644,
	"./Cave Goblin Card.png": 645,
	"./Cave Goblin Foil.png": 646,
	"./Cave Goblin Trapper Card.png": 647,
	"./Cave Goblin Trapper Foil.png": 648,
	"./Ceb Card.png": 649,
	"./Ceb Foil.png": 650,
	"./Chef Apron.png": 651,
	"./Chef Hat.png": 652,
	"./Chemistry Skill Orb (g).png": 653,
	"./Chemistry Skill Orb.png": 654,
	"./Cherries.png": 655,
	"./Cherry Pie.png": 656,
	"./Cherry Seeds.png": 657,
	"./Chicken Card.png": 658,
	"./Chicken Curry.png": 659,
	"./Chicken Foil.png": 660,
	"./Chicken Head.png": 661,
	"./Chicken Kebab.png": 662,
	"./Chicken Ring.png": 663,
	"./Chicken Soup.png": 664,
	"./Chicken.png": 665,
	"./Christmas Cloak.png": 666,
	"./Christmas Present.png": 667,
	"./Christmas Stocking.png": 668,
	"./Chucken Card.png": 669,
	"./Chucken Curry.png": 670,
	"./Chucken Foil.png": 671,
	"./Chucken Kebab.png": 672,
	"./Chucken Soup.png": 673,
	"./Chucken.png": 674,
	"./Ciggie.png": 675,
	"./Clay Golem Card.png": 676,
	"./Clay Golem Foil.png": 677,
	"./Clay.png": 678,
	"./Cloak of Destruction.png": 679,
	"./Cloak of Freedom.png": 680,
	"./Cloak of Romance.png": 681,
	"./Cloak of the Goat.png": 682,
	"./Cloak of the Guild.png": 683,
	"./Clown.png": 684,
	"./Coal Ore.png": 685,
	"./Coins.png": 203,
	"./Combat Actuator.png": 686,
	"./Compost.png": 687,
	"./Copper 2H Sword.png": 688,
	"./Copper 2H Warhammer.png": 689,
	"./Copper Acacia Arrows.png": 690,
	"./Copper Arrowheads.png": 691,
	"./Copper Axe.png": 692,
	"./Copper Baobab Arrows.png": 693,
	"./Copper Bar.png": 694,
	"./Copper Battleaxe.png": 695,
	"./Copper Bolts.png": 696,
	"./Copper Boots.png": 697,
	"./Copper Buckler.png": 698,
	"./Copper Chainbody.png": 699,
	"./Copper Dagger.png": 700,
	"./Copper Deadwood Arrows.png": 701,
	"./Copper Dragon Plasma.png": 702,
	"./Copper Gladius.png": 703,
	"./Copper Gloves.png": 704,
	"./Copper Halberd.png": 705,
	"./Copper Helmet.png": 706,
	"./Copper Katana.png": 707,
	"./Copper Kiteshield.png": 708,
	"./Copper Leather Boots.png": 709,
	"./Copper Leather Gloves.png": 710,
	"./Copper Leather Hat.png": 711,
	"./Copper Leather Robe Bottom.png": 712,
	"./Copper Leather Robe Top.png": 713,
	"./Copper Long Sword.png": 714,
	"./Copper Mace.png": 715,
	"./Copper Oak Arrows.png": 716,
	"./Copper Ore.png": 717,
	"./Copper Pickaxe.png": 718,
	"./Copper Pine Arrows.png": 719,
	"./Copper Platebody.png": 720,
	"./Copper Platelegs.png": 721,
	"./Copper Plateskirt.png": 722,
	"./Copper Psywood Arrows.png": 723,
	"./Copper Redwood Arrows.png": 724,
	"./Copper Scimitar.png": 725,
	"./Copper Short Sword.png": 726,
	"./Copper Spear.png": 727,
	"./Copper Staff.png": 728,
	"./Copper Throwing Knife.png": 729,
	"./Copper Warhammer.png": 730,
	"./Copper Weerwood Arrows.png": 731,
	"./Copper Willow Arrows.png": 732,
	"./Copper Yellowwood Arrows.png": 733,
	"./Cosmetic Coin.png": 734,
	"./Cowboy Hat.png": 735,
	"./Crab.png": 736,
	"./Crablante Card.png": 737,
	"./Crablante Claw.png": 738,
	"./Crablante Foil.png": 739,
	"./Crossbow Tigerman Card.png": 740,
	"./Crossbow Tigerman Foil.png": 741,
	"./Crown of Nebuchadnezzar.png": 742,
	"./Cucumber Seeds.png": 743,
	"./Cucumber.png": 744,
	"./Cultist Boots.png": 745,
	"./Cultist Card.png": 746,
	"./Cultist Foil.png": 747,
	"./Cultist Gloves.png": 748,
	"./Cultist Hat.png": 749,
	"./Cultist Robe Bottom.png": 750,
	"./Cultist Robe Top.png": 751,
	"./Cursed Actuator.png": 752,
	"./Cursed Claws.png": 753,
	"./Cursed Yeti Card.png": 754,
	"./Cursed Yeti Foil.png": 755,
	"./D. Ironman Helmet.png": 756,
	"./D. Ironman Platebody.png": 757,
	"./D. Ironman Platelegs.png": 758,
	"./Damascus 2H Sword.png": 759,
	"./Damascus 2H Warhammer.png": 760,
	"./Damascus Arrowheads.png": 761,
	"./Damascus Axe.png": 762,
	"./Damascus Baobab Arrows.png": 763,
	"./Damascus Bar.png": 764,
	"./Damascus Battleaxe.png": 765,
	"./Damascus Bolts.png": 766,
	"./Damascus Bond.png": 767,
	"./Damascus Boots.png": 768,
	"./Damascus Buckler.png": 769,
	"./Damascus Bullets.png": 770,
	"./Damascus Chainbody.png": 771,
	"./Damascus Crossbow.png": 772,
	"./Damascus Dagger.png": 773,
	"./Damascus Dragon Card.png": 774,
	"./Damascus Dragon Foil.png": 775,
	"./Damascus Dragon Plasma.png": 776,
	"./Damascus Gladius.png": 777,
	"./Damascus Gloves.png": 778,
	"./Damascus Halberd.png": 779,
	"./Damascus Helmet.png": 780,
	"./Damascus Katana.png": 781,
	"./Damascus Kiteshield.png": 782,
	"./Damascus Long Sword.png": 783,
	"./Damascus Mace.png": 784,
	"./Damascus Microbond (u).png": 785,
	"./Damascus Microbond.png": 786,
	"./Damascus Ore.png": 787,
	"./Damascus Pickaxe.png": 788,
	"./Damascus Pistol.png": 789,
	"./Damascus Platebody.png": 790,
	"./Damascus Platelegs.png": 791,
	"./Damascus Plateskirt.png": 792,
	"./Damascus Redwood Arrows.png": 793,
	"./Damascus Rifle.png": 794,
	"./Damascus Scimitar.png": 795,
	"./Damascus Short Sword.png": 796,
	"./Damascus Spear.png": 797,
	"./Damascus Throwing Knife.png": 798,
	"./Damascus Warhammer.png": 799,
	"./Damascus Weerwood Arrows.png": 800,
	"./Dead Eye Jones Card.png": 801,
	"./Dead Eye Jones Foil.png": 802,
	"./Deadwood Arrow Shafts.png": 803,
	"./Deadwood Bark.png": 804,
	"./Deadwood Logs.png": 805,
	"./Deadwood Longbow.png": 806,
	"./Deadwood Shortbow.png": 807,
	"./Deadwood Staff.png": 808,
	"./Deb Card.png": 809,
	"./Deb Foil.png": 810,
	"./Debarking Tool.png": 811,
	"./Defence Potion.png": 812,
	"./Defense Skill Orb (g).png": 813,
	"./Defense Skill Orb.png": 814,
	"./Dehydrated Cactuson Card.png": 815,
	"./Dehydrated Cactuson Foil.png": 816,
	"./Demon Cloak.png": 817,
	"./Demon Hat.png": 818,
	"./Demon Prince Card.png": 819,
	"./Demon Prince Foil.png": 820,
	"./Demon Slayer Katana.png": 821,
	"./Demon Tail.png": 822,
	"./Demonic Axe.png": 823,
	"./Demonic Crossbow.png": 824,
	"./Demonic Fish 2020.png": 825,
	"./Demonic Fish 2021.png": 826,
	"./Demonic Fish.png": 827,
	"./Demonic Fishing Rod.png": 828,
	"./Demonic Logs 2020.png": 829,
	"./Demonic Logs 2021.png": 830,
	"./Demonic Logs.png": 831,
	"./Demonic Net.png": 832,
	"./Demonic Ore 2020.png": 833,
	"./Demonic Ore 2021.png": 834,
	"./Demonic Ore.png": 835,
	"./Demonic Pickaxe.png": 836,
	"./Demonic Scimitar.png": 837,
	"./Demonic Shards.png": 838,
	"./Demonic Spade.png": 839,
	"./Demonic Staff.png": 840,
	"./Destruction Potion.png": 841,
	"./Destruction Skill Orb (g).png": 842,
	"./Destruction Skill Orb.png": 843,
	"./Diamond.png": 844,
	"./Dominia E. Stone.png": 845,
	"./Dragon Curry.png": 846,
	"./Dragon Gas.png": 847,
	"./Dragon Hide Boots.png": 848,
	"./Dragon Hide Gloves.png": 849,
	"./Dragon Hide Hood.png": 850,
	"./Dragon Hide Pants.png": 851,
	"./Dragon Hide Top.png": 852,
	"./Dragon Meat.png": 853,
	"./Dragon Soup.png": 854,
	"./Dragon Sushi.png": 855,
	"./Dragon's Eye.png": 856,
	"./Dwarf Card.png": 857,
	"./Dwarf Foil.png": 858,
	"./Dwarf Guard Card.png": 859,
	"./Dwarf Guard Foil.png": 860,
	"./E. Copper 2H Sword.png": 861,
	"./E. Copper 2H Warhammer.png": 862,
	"./E. Copper Acacia Arrows.png": 863,
	"./E. Copper Arrowheads.png": 864,
	"./E. Copper Axe.png": 865,
	"./E. Copper Baobab Arrows.png": 866,
	"./E. Copper Bar.png": 867,
	"./E. Copper Battleaxe.png": 868,
	"./E. Copper Bolts.png": 869,
	"./E. Copper Boots.png": 870,
	"./E. Copper Buckler.png": 871,
	"./E. Copper Bullets.png": 872,
	"./E. Copper Chainbody.png": 873,
	"./E. Copper Crossbow.png": 874,
	"./E. Copper Dagger.png": 875,
	"./E. Copper Gladius.png": 876,
	"./E. Copper Gloves.png": 877,
	"./E. Copper Halberd.png": 878,
	"./E. Copper Helmet.png": 879,
	"./E. Copper Katana.png": 880,
	"./E. Copper Kiteshield.png": 881,
	"./E. Copper Long Sword.png": 882,
	"./E. Copper Mace.png": 883,
	"./E. Copper Pickaxe.png": 884,
	"./E. Copper Pistol.png": 885,
	"./E. Copper Platebody.png": 886,
	"./E. Copper Platelegs.png": 887,
	"./E. Copper Plateskirt.png": 888,
	"./E. Copper Psywood Arrows.png": 889,
	"./E. Copper Redwood Arrows.png": 890,
	"./E. Copper Rifle.png": 891,
	"./E. Copper Scimitar.png": 892,
	"./E. Copper Short Sword.png": 893,
	"./E. Copper Spear.png": 894,
	"./E. Copper Staff.png": 895,
	"./E. Copper Throwing Knife.png": 896,
	"./E. Copper Warhammer.png": 897,
	"./E. Copper Weerwood Arrows.png": 898,
	"./E. Damascus 2H Sword.png": 899,
	"./E. Damascus 2H Warhammer.png": 900,
	"./E. Damascus Axe.png": 901,
	"./E. Damascus Battleaxe.png": 902,
	"./E. Damascus Boots.png": 903,
	"./E. Damascus Buckler.png": 904,
	"./E. Damascus Chainbody.png": 905,
	"./E. Damascus Dagger.png": 906,
	"./E. Damascus Gladius.png": 907,
	"./E. Damascus Gloves.png": 908,
	"./E. Damascus Halbred.png": 909,
	"./E. Damascus Helmet.png": 910,
	"./E. Damascus Katana.png": 911,
	"./E. Damascus Kiteshield.png": 912,
	"./E. Damascus Long Sword.png": 913,
	"./E. Damascus Mace.png": 914,
	"./E. Damascus Platebody.png": 915,
	"./E. Damascus Platelegs.png": 916,
	"./E. Damascus Plateskirt.png": 917,
	"./E. Damascus Scimitar.png": 918,
	"./E. Damascus Short Sword.png": 919,
	"./E. Damascus Spear.png": 920,
	"./E. Damascus Warhammer.png": 921,
	"./E. Gold 2H Sword.png": 922,
	"./E. Gold 2H Warhammer.png": 923,
	"./E. Gold Acacia Arrows.png": 924,
	"./E. Gold Arrowheads.png": 925,
	"./E. Gold Axe.png": 926,
	"./E. Gold Baobab Arrows.png": 927,
	"./E. Gold Bar.png": 928,
	"./E. Gold Battleaxe.png": 929,
	"./E. Gold Bolts.png": 930,
	"./E. Gold Boots.png": 931,
	"./E. Gold Buckler.png": 932,
	"./E. Gold Bullets.png": 933,
	"./E. Gold Chainbody.png": 934,
	"./E. Gold Crossbow.png": 935,
	"./E. Gold Dagger.png": 936,
	"./E. Gold Gladius.png": 937,
	"./E. Gold Gloves.png": 938,
	"./E. Gold Halberd.png": 939,
	"./E. Gold Helmet.png": 940,
	"./E. Gold Katana.png": 941,
	"./E. Gold Kiteshield.png": 942,
	"./E. Gold Long Sword.png": 943,
	"./E. Gold Mace.png": 944,
	"./E. Gold Pickaxe.png": 945,
	"./E. Gold Pistol.png": 946,
	"./E. Gold Platebody.png": 947,
	"./E. Gold Platelegs.png": 948,
	"./E. Gold Plateskirt.png": 949,
	"./E. Gold Redwood Arrows.png": 950,
	"./E. Gold Rifle.png": 951,
	"./E. Gold Scimitar.png": 952,
	"./E. Gold Short Sword.png": 953,
	"./E. Gold Spear.png": 954,
	"./E. Gold Throwing Knife.png": 955,
	"./E. Gold Warhammer.png": 956,
	"./E. Gold Weerwood Arrows.png": 957,
	"./Earth Elemental Card.png": 958,
	"./Earth Elemental Foil.png": 959,
	"./Earth Slime Card.png": 960,
	"./Earth Slime Foil.png": 961,
	"./Easter Cloak.png": 962,
	"./Easter Egg.png": 963,
	"./Easter Jon.png": 964,
	"./Easter Shield.png": 965,
	"./Eggs.png": 966,
	"./Elemental Ale.png": 967,
	"./Elemental Berries.png": 968,
	"./Emerald Blade.png": 969,
	"./Emerald.png": 970,
	"./Empty Plasma Bottle.png": 971,
	"./Empty Vial Package.png": 972,
	"./Enchanted Heart.png": 973,
	"./Enchanted Ice.png": 974,
	"./Enraged Cactuson Card.png": 975,
	"./Enraged Cactuson Foil.png": 976,
	"./Explosives Skill Orb (g).png": 977,
	"./Explosives Skill Orb.png": 978,
	"./Fairy Card.png": 979,
	"./Fairy Foil.png": 980,
	"./Fairy King Card.png": 981,
	"./Fairy King Foil.png": 982,
	"./Fairy Knight Card.png": 983,
	"./Fairy Knight Foil.png": 984,
	"./Fairy Queen Card.png": 985,
	"./Fairy Queen Foil.png": 986,
	"./Fairy Rider Card.png": 987,
	"./Fairy Rider Foil.png": 988,
	"./Fairy Warrior Card.png": 989,
	"./Fairy Warrior Foil.png": 990,
	"./Farming Skill Orb (g).png": 991,
	"./Farming Skill Orb.png": 992,
	"./Feather.png": 993,
	"./Fiery Boots.png": 994,
	"./Fiery Gloves.png": 995,
	"./Fiery Hood.png": 996,
	"./Fiery Pants.png": 997,
	"./Fiery Top.png": 998,
	"./Fire Demon Card.png": 999,
	"./Fire Demon Foil.png": 1000,
	"./Fire Elemental Card.png": 1001,
	"./Fire Elemental Foil.png": 1002,
	"./Fire Giant Card.png": 1003,
	"./Fire Giant Foil.png": 1004,
	"./Fire Slime Card.png": 1005,
	"./Fire Slime Foil.png": 1006,
	"./Fire Snake Card.png": 1007,
	"./Fire Snake Foil.png": 1008,
	"./Fireworks Package.png": 1009,
	"./Fishing Net.png": 1010,
	"./Fishing Rod.png": 1011,
	"./Flaming Demon.png": 1012,
	"./Fletching Skill Orb (g).png": 1013,
	"./Fletching Skill Orb.png": 1014,
	"./Flour.png": 1015,
	"./Flowering Cactuson Card.png": 1016,
	"./Flowering Cactuson Foil.png": 1017,
	"./Forest Demon Card.png": 1018,
	"./Forest Demon Foil.png": 1019,
	"./Forgotten Buckler.png": 1020,
	"./Freedom Facepaint.png": 1021,
	"./Freedom Firecracker.png": 1022,
	"./Freedom Hat.png": 1023,
	"./Freedom Shield.png": 1024,
	"./Frogman Ambassador Card.png": 1025,
	"./Frogman Ambassador Foil.png": 1026,
	"./Frogman Archer Card.png": 1027,
	"./Frogman Archer Foil.png": 1028,
	"./Frogman Card.png": 1029,
	"./Frogman Foil.png": 1030,
	"./Frogman King Card.png": 1031,
	"./Frogman King Foil.png": 1032,
	"./Frogman Mage Card.png": 1033,
	"./Frogman Mage Foil.png": 1034,
	"./Frogman Warrior Card.png": 1035,
	"./Frogman Warrior Foil.png": 1036,
	"./Frost Demon Card.png": 1037,
	"./Frost Demon Foil.png": 1038,
	"./Frost Giant Card.png": 1039,
	"./Frost Giant Foil.png": 1040,
	"./Ghost Outfit.png": 1041,
	"./Giant Bear Card.png": 1042,
	"./Giant Bear Foil.png": 1043,
	"./Giant Skeleton Card.png": 1044,
	"./Giant Skeleton Foil.png": 1045,
	"./Giant Spider Card.png": 1046,
	"./Giant Spider Foil.png": 1047,
	"./Giant Squid.png": 1048,
	"./Gladiatorial Ring.png": 1049,
	"./Goat King Card.png": 1050,
	"./Goat King Foil.png": 1051,
	"./Goatman Card.png": 1052,
	"./Goatman Foil.png": 1053,
	"./Goblin Berserker Card.png": 1054,
	"./Goblin Berserker Foil.png": 1055,
	"./Goblin Card.png": 1056,
	"./Goblin Champion Card.png": 1057,
	"./Goblin Champion Foil.png": 1058,
	"./Goblin Foil.png": 1059,
	"./Goblin King Card.png": 1060,
	"./Goblin King Foil.png": 1061,
	"./Goblin Outfit.png": 1062,
	"./Goblin Swashbuckler Card.png": 1063,
	"./Goblin Swashbuckler Foil.png": 1064,
	"./Goblin Warrior Card.png": 1065,
	"./Goblin Warrior Foil.png": 1066,
	"./Gold Bar.png": 1067,
	"./Gold Dragon Plasma.png": 1068,
	"./Gold Ore.png": 1069,
	"./Greataxe of the Goat.png": 1070,
	"./Greater Actuator.png": 1071,
	"./Greater Earth Slime Card.png": 1072,
	"./Greater Earth Slime Foil.png": 1073,
	"./Greater Fire Slime Card.png": 1074,
	"./Greater Fire Slime Foil.png": 1075,
	"./Greater Lightning Slime Card.png": 1076,
	"./Greater Lightning Slime Foil.png": 1077,
	"./Greater Slime Card.png": 1078,
	"./Greater Slime Foil.png": 1079,
	"./Greater Water Slime Card.png": 1080,
	"./Greater Water Slime Foil.png": 1081,
	"./Greater Wind Slime Card.png": 1082,
	"./Greater Wind Slime Foil.png": 1083,
	"./Green Beanie.png": 1084,
	"./Green Dragon Card.png": 1085,
	"./Green Dragon Foil.png": 1086,
	"./Green Dragon Plasma.png": 1087,
	"./Green Firecracker.png": 1088,
	"./Green Scarf.png": 1089,
	"./Guard Card.png": 1090,
	"./Guard Foil.png": 1091,
	"./Guild Apprentice Gloves.png": 1092,
	"./Guild Apprentice Helm.png": 1093,
	"./Guild Master Gloves.png": 1094,
	"./Guild Master Helm.png": 1095,
	"./Guilded Cloak.png": 1096,
	"./Guildwork Contract.png": 1097,
	"./Guildwork Skill Orb (g).png": 1098,
	"./Guildwork Skill Orb.png": 1099,
	"./Gunpowder Keg.png": 1100,
	"./Gunpowder Package.png": 1101,
	"./Gunpowder.png": 1102,
	"./Guppie.png": 1103,
	"./H. Ironman Helmet.png": 1104,
	"./H. Ironman Platebody.png": 1105,
	"./H. Ironman Platelegs.png": 1106,
	"./HD. Ironman Helmet.png": 1107,
	"./HD. Ironman Platebody.png": 1108,
	"./HD. Ironman Platelegs.png": 1109,
	"./Halloween Seeds.png": 1110,
	"./Halo.png": 1111,
	"./Hat Demon Outfit.png": 1112,
	"./Hazmat Boots.png": 1113,
	"./Hazmat Gloves.png": 1114,
	"./Hazmat Mask.png": 1115,
	"./Hazmat Pants.png": 1116,
	"./Hazmat Top.png": 1117,
	"./Healing Actuator.png": 1118,
	"./Health Potion.png": 1119,
	"./Health Skill Orb (g).png": 1120,
	"./Health Skill Orb.png": 1121,
	"./Heart Shield.png": 1122,
	"./Helm of the Bull.png": 1123,
	"./Highwayman Card.png": 1124,
	"./Highwayman Foil.png": 1125,
	"./Honey Badger Hide Boots.png": 1126,
	"./Honey Badger Hide Gloves.png": 1127,
	"./Honey Badger Hide Hood.png": 1128,
	"./Honey Badger Hide Pants.png": 1129,
	"./Honey Badger Hide Top.png": 1130,
	"./Icewyntale E. Stone.png": 1131,
	"./Iron 2H Sword.png": 1132,
	"./Iron 2H Warhammer.png": 1133,
	"./Iron Acacia Arrows.png": 1134,
	"./Iron Arrowheads.png": 1135,
	"./Iron Axe.png": 1136,
	"./Iron Baobab Arrows.png": 1137,
	"./Iron Bar.png": 1138,
	"./Iron Battleaxe.png": 1139,
	"./Iron Bolts.png": 1140,
	"./Iron Boots.png": 1141,
	"./Iron Buckler.png": 1142,
	"./Iron Chainbody.png": 1143,
	"./Iron Dagger.png": 1144,
	"./Iron Dragon Boots.png": 1145,
	"./Iron Dragon Gloves.png": 1146,
	"./Iron Dragon Hat.png": 1147,
	"./Iron Dragon Robe Bottom.png": 1148,
	"./Iron Dragon Robe Top.png": 1149,
	"./Iron Gladius.png": 1150,
	"./Iron Gloves.png": 1151,
	"./Iron Halberd.png": 1152,
	"./Iron Helmet.png": 1153,
	"./Iron Katana.png": 1154,
	"./Iron Kiteshield.png": 1155,
	"./Iron Long Sword.png": 1156,
	"./Iron Mace.png": 1157,
	"./Iron Oak Arrows.png": 1158,
	"./Iron Ore.png": 1159,
	"./Iron Pickaxe.png": 1160,
	"./Iron Platebody.png": 1161,
	"./Iron Platelegs.png": 1162,
	"./Iron Plateskirt.png": 1163,
	"./Iron Psywood Arrows.png": 1164,
	"./Iron Redwood Arrows.png": 1165,
	"./Iron Scimitar.png": 1166,
	"./Iron Short Sword.png": 1167,
	"./Iron Spear.png": 1168,
	"./Iron Staff.png": 1169,
	"./Iron Throwing Knife.png": 1170,
	"./Iron Warhammer.png": 1171,
	"./Iron Weerwood Arrows.png": 1172,
	"./Iron Willow Arrows.png": 1173,
	"./Iron Yellowwood Arrows.png": 1174,
	"./Ironman Helmet.png": 1175,
	"./Ironman Platebody.png": 1176,
	"./Ironman Platelegs.png": 1177,
	"./Jaime Goliver Card.png": 1178,
	"./Jaime Goliver Foil.png": 1179,
	"./Jealous Witch Card.png": 1180,
	"./Jealous Witch Foil.png": 1181,
	"./Jester Hat.png": 1182,
	"./Jon Suit.png": 1183,
	"./Krampus Mask.png": 1184,
	"./Lamb Curry.png": 1185,
	"./Lamb Kebab.png": 1186,
	"./Lamb Soup.png": 1187,
	"./Lamb.png": 1188,
	"./Large Accuracy Potion.png": 1189,
	"./Large Defence Potion.png": 1190,
	"./Large Destruction Potion.png": 1191,
	"./Large Freeze Grenade.png": 1192,
	"./Large Gas Grenade.png": 1193,
	"./Large Grenade.png": 1194,
	"./Large Health Potion.png": 1195,
	"./Large Melee Potion.png": 1196,
	"./Large Napalm Grenade.png": 1197,
	"./Large Psychic Potion.png": 1198,
	"./Large Ranging Potion.png": 1199,
	"./Large Stamina Potion.png": 1200,
	"./Leather Boots.png": 1201,
	"./Leather Gloves.png": 1202,
	"./Leather Hood.png": 1203,
	"./Leather Pants.png": 1204,
	"./Leather Top.png": 1205,
	"./Lesser Actuator.png": 1206,
	"./Lesser Demon Card.png": 1207,
	"./Lesser Demon Foil.png": 1208,
	"./Lesser Earth Slime Card.png": 1209,
	"./Lesser Earth Slime Foil.png": 1210,
	"./Lesser Fire Slime Card.png": 1211,
	"./Lesser Fire Slime Foil.png": 1212,
	"./Lesser Lightning Slime Card.png": 1213,
	"./Lesser Lightning Slime Foil.png": 1214,
	"./Lesser Slime Card.png": 1215,
	"./Lesser Slime Foil.png": 1216,
	"./Lesser Water Slime Card.png": 1217,
	"./Lesser Water Slime Foil.png": 1218,
	"./Lesser Wind Slime Card.png": 1219,
	"./Lesser Wind Slime Foil.png": 1220,
	"./Lettuce Seeds.png": 1221,
	"./Lettuce.png": 1222,
	"./Lieutenant Cae Card.png": 1223,
	"./Lieutenant Cae Foil.png": 1224,
	"./Lieutenant Cra Card.png": 1225,
	"./Lieutenant Cra Foil.png": 1226,
	"./Lieutenant Pom Card.png": 1227,
	"./Lieutenant Pom Foil.png": 1228,
	"./Lightning Slime Card.png": 1229,
	"./Lightning Slime Foil.png": 1230,
	"./Liquid Nitrogen.png": 1231,
	"./Lobster.png": 1232,
	"./Luchador.png": 1233,
	"./MDGA Cap.png": 1234,
	"./Magenta Firecracker.png": 1235,
	"./Man Card.png": 1236,
	"./Man Foil.png": 1237,
	"./Matchbox.png": 1238,
	"./Mead.png": 1239,
	"./Meat Sack.png": 1240,
	"./Mechanics Skill Orb (g).png": 1241,
	"./Mechanics Skill Orb.png": 1242,
	"./Medium Freeze Grenade.png": 1243,
	"./Medium Gas Grenade.png": 1244,
	"./Medium Grenade.png": 1245,
	"./Medium Lifesteal Grenade.png": 1246,
	"./Medium Napalm Grenade.png": 1247,
	"./Melee Potion.png": 1248,
	"./Melee Skill Orb (g).png": 1249,
	"./Melee Skill Orb.png": 1250,
	"./Metalwork Skill Orb (g).png": 1251,
	"./Metalwork Skill Orb.png": 1252,
	"./Milk.png": 1253,
	"./Mining Skill Orb (g).png": 1254,
	"./Mining Skill Orb.png": 1255,
	"./Money Bag.png": 1256,
	"./Moose Curry.png": 1257,
	"./Moose Kebab.png": 1258,
	"./Moose Soup.png": 1259,
	"./Moose.png": 1260,
	"./Mt. Greeff E. Stone.png": 1261,
	"./Mug.png": 1262,
	"./Mutated Hydra Card.png": 1263,
	"./Mutated Hydra Foil.png": 1264,
	"./Napalm.png": 1265,
	"./Ninja Mask.png": 1266,
	"./Nitrogen Gas.png": 1267,
	"./Nurse Cody.png": 1268,
	"./Oak Arrow Shafts.png": 1269,
	"./Oak Bark.png": 1270,
	"./Oak Logs.png": 1271,
	"./Oak Longbow.png": 1272,
	"./Oak Sapling.png": 1273,
	"./Oak Seed.png": 1274,
	"./Oak Shortbow.png": 1275,
	"./Oak Staff.png": 1276,
	"./Oil.png": 1277,
	"./Onion Seeds.png": 1278,
	"./Onion.png": 1279,
	"./Orc Archer Card.png": 1280,
	"./Orc Archer Foil.png": 1281,
	"./Orc Beserker Card.png": 1282,
	"./Orc Beserker Foil.png": 1283,
	"./Orc Card.png": 1284,
	"./Orc Foil.png": 1285,
	"./Orc King Card.png": 1286,
	"./Orc King Foil.png": 1287,
	"./Orc Shaman Card.png": 1288,
	"./Orc Shaman Foil.png": 1289,
	"./Orc War Chief Card.png": 1290,
	"./Orc War Chief Foil.png": 1291,
	"./Orc Warrior Card.png": 1292,
	"./Orc Warrior Foil.png": 1293,
	"./Owlman Archer Card.png": 1294,
	"./Owlman Archer Foil.png": 1295,
	"./Owlman Card.png": 1296,
	"./Owlman Foil.png": 1297,
	"./Owlman King Card.png": 1298,
	"./Owlman King Foil.png": 1299,
	"./Owlman Sage Card.png": 1300,
	"./Owlman Sage Foil.png": 1301,
	"./Owlman Warrior Card.png": 1302,
	"./Owlman Warrior Foil.png": 1303,
	"./Oyster.png": 1304,
	"./Pebbles.png": 1305,
	"./Pine Arrow Shafts.png": 1306,
	"./Pine Bark.png": 1307,
	"./Pine Logs.png": 1308,
	"./Pine Longbow.png": 1309,
	"./Pine Shortbow.png": 1310,
	"./Pine Staff.png": 1311,
	"./Pineapple Staff.png": 1312,
	"./Pirate Bandana.png": 1313,
	"./Pitchfork Demon.png": 1314,
	"./Pizza.png": 1315,
	"./Plasma Belt.png": 1316,
	"./Plasma Vial Package.png": 1317,
	"./Poison Stone.png": 1318,
	"./Pork Curry.png": 1319,
	"./Pork Kebab.png": 1320,
	"./Pork Soup.png": 1321,
	"./Pork.png": 1322,
	"./Port Tall E. Stone.png": 1323,
	"./Pot of Earth.png": 1324,
	"./Pot.png": 1325,
	"./Potash.png": 1326,
	"./Potato Head.png": 1327,
	"./Potato Seeds.png": 1328,
	"./Potato.png": 1329,
	"./Pothead.png": 1330,
	"./Psy Vial Package.png": 1331,
	"./Psy Vial of Water.png": 1332,
	"./Psy Vial.png": 1333,
	"./Psychic Orc Card.png": 1334,
	"./Psychic Orc Foil.png": 1335,
	"./Psychic Potion.png": 1336,
	"./Psychic Sapling.png": 1337,
	"./Psychic Skill Orb (g).png": 1338,
	"./Psychic Skill Orb.png": 1339,
	"./Psywood 2H Sword.png": 1340,
	"./Psywood 2H Warhammer.png": 1341,
	"./Psywood Acacia Arrows.png": 1342,
	"./Psywood Arrow Shafts.png": 1343,
	"./Psywood Arrowheads.png": 1344,
	"./Psywood Arrows.png": 1345,
	"./Psywood Axe.png": 1346,
	"./Psywood Baobab Arrows.png": 1347,
	"./Psywood Bar.png": 1348,
	"./Psywood Bark.png": 1349,
	"./Psywood Battleaxe.png": 1350,
	"./Psywood Bolts.png": 1351,
	"./Psywood Boots.png": 1352,
	"./Psywood Buckler.png": 1353,
	"./Psywood Bullets.png": 1354,
	"./Psywood Chainbody.png": 1355,
	"./Psywood Crossbow.png": 1356,
	"./Psywood Dagger.png": 1357,
	"./Psywood Gladius.png": 1358,
	"./Psywood Gloves.png": 1359,
	"./Psywood Halberd.png": 1360,
	"./Psywood Helmet.png": 1361,
	"./Psywood Honey Badger Boots.png": 1362,
	"./Psywood Honey Badger Gloves.png": 1363,
	"./Psywood Honey Badger Hat.png": 1364,
	"./Psywood Honey Badger Robe Bottom.png": 1365,
	"./Psywood Honey Badger Robe Top.png": 1366,
	"./Psywood Katana.png": 1367,
	"./Psywood Kiteshield.png": 1368,
	"./Psywood Logs.png": 1369,
	"./Psywood Long Sword.png": 1370,
	"./Psywood Longbow.png": 1371,
	"./Psywood Mace.png": 1372,
	"./Psywood Pickaxe.png": 1373,
	"./Psywood Pistol.png": 1374,
	"./Psywood Platebody.png": 1375,
	"./Psywood Platelegs.png": 1376,
	"./Psywood Plateskirt.png": 1377,
	"./Psywood Redwood Arrows.png": 1378,
	"./Psywood Rifle.png": 1379,
	"./Psywood Scimitar.png": 1380,
	"./Psywood Seed.png": 1381,
	"./Psywood Short Sword.png": 1382,
	"./Psywood Shortbow.png": 1383,
	"./Psywood Spear.png": 1384,
	"./Psywood Staff.png": 1385,
	"./Psywood Throwing Knife.png": 1386,
	"./Psywood Warhammer.png": 1387,
	"./Psywood Weerwood Arrows.png": 1388,
	"./Psywood Yellowwood Arrows.png": 1389,
	"./Pumpkin Cloak.png": 1390,
	"./Pumpkin Mask.png": 1391,
	"./Pumpkin.png": 1392,
	"./Punk Card.png": 1393,
	"./Punk Foil.png": 1394,
	"./Purple Beanie.png": 1395,
	"./Purple Firecracker.png": 1396,
	"./Purple Scarf.png": 1397,
	"./Rainbow Man.png": 1398,
	"./Ranging Potion.png": 1399,
	"./Ranging Skill Orb (g).png": 1400,
	"./Ranging Skill Orb.png": 1401,
	"./Rat Card.png": 1402,
	"./Rat Foil.png": 1403,
	"./Ratman Beserker Card.png": 1404,
	"./Ratman Beserker Foil.png": 1405,
	"./Ratman Card.png": 1406,
	"./Ratman Foil.png": 1407,
	"./Ratman Guard Card.png": 1408,
	"./Ratman Guard Foil.png": 1409,
	"./Ratman King Card.png": 1410,
	"./Ratman King Foil.png": 1411,
	"./Raw Barracuda.png": 1412,
	"./Raw Bear.png": 1413,
	"./Raw Beef.png": 1414,
	"./Raw Chicken.png": 1415,
	"./Raw Chucken.png": 1416,
	"./Raw Crab.png": 1417,
	"./Raw Dragon.png": 1418,
	"./Raw Giant Squid.png": 1419,
	"./Raw Guppie.png": 1420,
	"./Raw Lamb.png": 1421,
	"./Raw Lobster.png": 1422,
	"./Raw Moose.png": 1423,
	"./Raw Oyster.png": 1424,
	"./Raw Pork.png": 1425,
	"./Raw Salmon.png": 1426,
	"./Raw Sturgeon.png": 1427,
	"./Raw Tigerfish.png": 1428,
	"./Raw Tortoise.png": 1429,
	"./Raw Tuna.png": 1430,
	"./Raw Unicorn.png": 1431,
	"./Red Beanie.png": 1432,
	"./Red Dragon Card.png": 1433,
	"./Red Dragon Foil.png": 1434,
	"./Red Firecracker.png": 1435,
	"./Red Scarf.png": 1436,
	"./Redwood Arrow Shafts.png": 1437,
	"./Redwood Bark.png": 1438,
	"./Redwood Logs.png": 1439,
	"./Redwood Longbow.png": 1440,
	"./Redwood Shortbow.png": 1441,
	"./Reindeer Antlers.png": 1442,
	"./Reinforced BoD.png": 1443,
	"./Rice Seeds.png": 1444,
	"./Rice.png": 1445,
	"./Ring of Christmas.png": 1446,
	"./Ring of Coins.png": 1447,
	"./Ring of Slime.png": 1448,
	"./Ring of Wool.png": 1449,
	"./Roast Bear.png": 1450,
	"./Roast Beef.png": 1451,
	"./Roast Dragon.png": 1452,
	"./Roast Lamb.png": 1453,
	"./Roast Moose.png": 1454,
	"./Roast Pork.png": 1455,
	"./Roast Tortoise.png": 1456,
	"./Roast Unicorn.png": 1457,
	"./Rogue's Rest E. Stone.png": 1458,
	"./Ruby.png": 1459,
	"./Salmon Sushi.png": 1460,
	"./Salmon.png": 1461,
	"./Sand Demon Card.png": 1462,
	"./Sand Demon Foil.png": 1463,
	"./Sandals.png": 1464,
	"./Santa Boots.png": 1465,
	"./Santa Hat.png": 1466,
	"./Santa Pants.png": 1467,
	"./Santa Top.png": 1468,
	"./Sapphire.png": 1469,
	"./Science Punk Card.png": 1470,
	"./Science Punk Foil.png": 1471,
	"./Seed Dibber.png": 1472,
	"./Serpent Dagger.png": 1473,
	"./Serpent Hilt.png": 1474,
	"./Shield of the Bull.png": 1475,
	"./Silver Bar.png": 1476,
	"./Silver Ore.png": 1477,
	"./Slime Card.png": 1478,
	"./Slime Foil.png": 1479,
	"./Slingshot.png": 1480,
	"./Small Bone Snake Card.png": 1481,
	"./Small Bone Snake Foil.png": 1482,
	"./Small Freeze Grenade.png": 1483,
	"./Small Gas Grenade.png": 1484,
	"./Small Grenade.png": 1485,
	"./Small Lifesteal Grenade.png": 1486,
	"./Small Napalm Grenade.png": 1487,
	"./Smuggler's Den E. Stone.png": 1488,
	"./Sombrero.png": 1489,
	"./Spade.png": 1490,
	"./Spectral Gloves.png": 1491,
	"./Spices.png": 1492,
	"./Split City E. Stone.png": 1493,
	"./Stamina Potion.png": 1494,
	"./Stamina Skill Orb (g).png": 1495,
	"./Stamina Skill Orb.png": 1496,
	"./Stealing Skill Orb (g).png": 1497,
	"./Stealing Skill Orb.png": 1498,
	"./Steel 2H Sword.png": 1499,
	"./Steel 2H Warhammer.png": 1500,
	"./Steel Acacia Arrows.png": 1501,
	"./Steel Arrowheads.png": 1502,
	"./Steel Axe.png": 1503,
	"./Steel Baobab Arrows.png": 1504,
	"./Steel Bar.png": 1505,
	"./Steel Battleaxe.png": 1506,
	"./Steel Bolts.png": 1507,
	"./Steel Boots.png": 1508,
	"./Steel Buckler.png": 1509,
	"./Steel Bullets.png": 1510,
	"./Steel Chainbody.png": 1511,
	"./Steel Crossbow.png": 1512,
	"./Steel Dagger.png": 1513,
	"./Steel Gladius.png": 1514,
	"./Steel Gloves.png": 1515,
	"./Steel Halberd.png": 1516,
	"./Steel Helmet.png": 1517,
	"./Steel Katana.png": 1518,
	"./Steel Kiteshield.png": 1519,
	"./Steel Long Sword.png": 1520,
	"./Steel Mace.png": 1521,
	"./Steel Pickaxe.png": 1522,
	"./Steel Pistol.png": 1523,
	"./Steel Platebody.png": 1524,
	"./Steel Platelegs.png": 1525,
	"./Steel Plateskirt.png": 1526,
	"./Steel Psywood Arrows.png": 1527,
	"./Steel Redwood Arrows.png": 1528,
	"./Steel Rifle.png": 1529,
	"./Steel Scimitar.png": 1530,
	"./Steel Short Sword.png": 1531,
	"./Steel Spear.png": 1532,
	"./Steel Staff.png": 1533,
	"./Steel Throwing Knife.png": 1534,
	"./Steel Unicorn Boots.png": 1535,
	"./Steel Unicorn Gloves.png": 1536,
	"./Steel Unicorn Hat.png": 1537,
	"./Steel Unicorn Robe Bottom.png": 1538,
	"./Steel Unicorn Robe Top.png": 1539,
	"./Steel Warhammer.png": 1540,
	"./Steel Weerwood Arrows.png": 1541,
	"./Steel Willow Arrows.png": 1542,
	"./Steel Yellowwood Arrows.png": 1543,
	"./Storm Giant Card.png": 1544,
	"./Storm Giant Foil.png": 1545,
	"./Straw Hat.png": 1546,
	"./String Package.png": 1547,
	"./String.png": 1548,
	"./Sturgeon.png": 1549,
	"./Sugar.png": 1550,
	"./Suit Pants.png": 1551,
	"./Suit Shoes.png": 1552,
	"./Suit Top.png": 1553,
	"./Sulphur.png": 1554,
	"./Super Luci.png": 1555,
	"./Survival Skill Orb (g).png": 1556,
	"./Survival Skill Orb.png": 1557,
	"./Swamp Demon Card.png": 1558,
	"./Swamp Demon Foil.png": 1559,
	"./Tamago.png": 1560,
	"./Tanzanite.png": 1561,
	"./Teal Firecracker.png": 1562,
	"./Teleport Actuator.png": 1563,
	"./Three River Fort E. Stone.png": 1564,
	"./Tigerfish.png": 1565,
	"./Tigerman Archer Card.png": 1566,
	"./Tigerman Archer Foil.png": 1567,
	"./Tigerman Captain Card.png": 1568,
	"./Tigerman Captain Foil.png": 1569,
	"./Tigerman Card.png": 1570,
	"./Tigerman Fighter Card.png": 1571,
	"./Tigerman Fighter Foil.png": 1572,
	"./Tigerman Foil.png": 1573,
	"./Tigerman King Card.png": 1574,
	"./Tigerman King Foil.png": 1575,
	"./Tikitama Card.png": 1576,
	"./Tikitama Foil.png": 1577,
	"./Tin Ore.png": 1578,
	"./Toga Bottom.png": 1579,
	"./Toga Top.png": 1580,
	"./Tomato Seeds.png": 1581,
	"./Tomato.png": 1582,
	"./Top Hat.png": 1583,
	"./Topaz.png": 1584,
	"./Tormaline.png": 1585,
	"./Tortoise Card.png": 1586,
	"./Tortoise Curry.png": 1587,
	"./Tortoise Foil.png": 1588,
	"./Tortoise Helmet.png": 1589,
	"./Tortoise Kebab.png": 1590,
	"./Tortoise Meat.png": 1591,
	"./Tortoise Shell.png": 1592,
	"./Tortoise Soup.png": 1593,
	"./Toxicity Meter.png": 1594,
	"./Toxicity Report.png": 1595,
	"./Trading Skill Orb (g).png": 1596,
	"./Trading Skill Orb.png": 1597,
	"./Tuna Sushi.png": 1598,
	"./Tuna.png": 1599,
	"./UFO.png": 1600,
	"./Unholy Bulwark.png": 1601,
	"./Unicorn Blood.png": 1602,
	"./Unicorn Card.png": 1603,
	"./Unicorn Curry.png": 1604,
	"./Unicorn Foil.png": 1605,
	"./Unicorn Kebab.png": 1606,
	"./Unicorn Leather Boots.png": 1607,
	"./Unicorn Leather Gloves.png": 1608,
	"./Unicorn Leather Hood.png": 1609,
	"./Unicorn Leather Pants.png": 1610,
	"./Unicorn Leather Top.png": 1611,
	"./Unicorn Soup.png": 1612,
	"./Unicorn.png": 1613,
	"./Uranium Ore.png": 1614,
	"./Utalagu Card.png": 1615,
	"./Utalagu Foil.png": 1616,
	"./Vial Package.png": 1617,
	"./Vial of Water.png": 1618,
	"./Vial.png": 1619,
	"./Violet Firecracker.png": 1620,
	"./Wasabi Paste.png": 1621,
	"./Wasabi Plant Starts.png": 1622,
	"./Water Elemental Card.png": 1623,
	"./Water Elemental Foil.png": 1624,
	"./Water Slime Card.png": 1625,
	"./Water Slime Foil.png": 1626,
	"./Wedding Dress.png": 1627,
	"./Weerwood Arrow Shafts.png": 1628,
	"./Weerwood Bark.png": 1629,
	"./Weerwood Logs.png": 1630,
	"./Weerwood Longbow.png": 1631,
	"./Weerwood Sapling.png": 1632,
	"./Weerwood Seed.png": 1633,
	"./Weerwood Shortbow.png": 1634,
	"./Wheat Seeds.png": 1635,
	"./Wheat.png": 1636,
	"./White Beanie.png": 1637,
	"./White Scarf.png": 1638,
	"./Willow Arrow Shafts.png": 1639,
	"./Willow Bark.png": 1640,
	"./Willow Logs.png": 1641,
	"./Willow Longbow.png": 1642,
	"./Willow Sapling.png": 1643,
	"./Willow Seed.png": 1644,
	"./Willow Shortbow.png": 1645,
	"./Willow Staff.png": 1646,
	"./Wind Elemental Card.png": 1647,
	"./Wind Elemental Foil.png": 1648,
	"./Wind Slime Card.png": 1649,
	"./Wind Slime Foil.png": 1650,
	"./Witch Hat.png": 1651,
	"./Wolfman Card.png": 1652,
	"./Wolfman Foil.png": 1653,
	"./Woman Card.png": 1654,
	"./Woman Foil.png": 1655,
	"./Wyn's Favorite Gloves.png": 1656,
	"./Yellow Dragon Card.png": 1657,
	"./Yellow Dragon Foil.png": 1658,
	"./Yellow Firecracker.png": 1659,
	"./Yellowwood Arrow Shafts.png": 1660,
	"./Yellowwood Bark.png": 1661,
	"./Yellowwood Logs.png": 1662,
	"./Yellowwood Longbow.png": 1663,
	"./Yellowwood Shortbow.png": 1664,
	"./Yellowwood Staff.png": 1665,
	"./Zenitsu Card.png": 1666,
	"./Zenitsu Foil.png": 1667,
	"./Zombie Card.png": 1668,
	"./Zombie Foil.png": 1669,
	"./Zorgling Card.png": 1670,
	"./Zorgling Foil.png": 1671
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 104;